import React from 'react';
import BookCover from '../components/Book';
import DetailDescription from "../components/DetailDescription";
import Reviews from "../components/Reviews";
import SectionTitle from '../components/SectionTitle';
import { Grid, Row, Col } from 'react-bootstrap';
import config from '../config'

class Details extends React.Component {
    render(){
        const i = this.props.booksData[0].books.findIndex((book) => book.url === this.props.params.id);
        const book = this.props.booksData[0].books[i];

        //WWW-5749 - iBooks to Apple Books
        if(config.author === "cmessud") {
            for (let i = 0; i < book.retailersLinks.length; i++) {
                book.retailersLinks[i].retailer 
                    = book.retailersLinks[i].retailer === "iBooks" 
                        ? "Apple Books" : book.retailersLinks[i].retailer;
            }
        }        
        
        //WWW-5750 - adding new links in buy now drowdown
        let confBook = config.books !== undefined ? config.books : null;
        let isFound = false;
        if(confBook !== null) {
            confBook.forEach(element => {
                if(element.title === book.title) {
                    element.retailersLinks.forEach(elem => {
                        book.retailersLinks.find(ele => {
                            if(ele.retailer === elem.retailer && isFound === false) {
                                isFound = true;
                            }
                        });
                        if(isFound === false) {
                            book.retailersLinks.push(elem);
                        }
                    });
                }
            });
        }

        //WWW-5750 - Sort the retailer links by retailer.
        if(config.author === "cmessud") {
            book.retailersLinks.sort(function (a, b) {
                var linkA = a.retailer.toUpperCase();
                var linkB = b.retailer.toUpperCase();
                if (linkA < linkB) {
                    return -1;
                }
                if (linkA > linkB) {
                    return 1;
                }
                return 0;
            });
        }

        const link = "/books/"+book.url;
        return (
            <div className="book-detail">
                <div className="detail-data">
                    <Grid>
                        <Row className="show-grid ">
                            <div>
                                <BookCover book={book} dropDownLinks={book.retailersLinks} buttonText={book.orderButtonText} link={link} />
                                <Col xs={12} md={6}>
                                    <div className="detail-title-description">
                                        <div className="section-title"> 
                                            <SectionTitle title={book.bookTitle} subtitle={book.subtitle}/>
                                        </div>
                                        <DetailDescription description={book.summary}/>
                                    </div>
                                </Col>
                            </div>
                        </Row>
                    </Grid>
                </div>
                <div className="detail-reviews">
                    <Grid>
                        <Row className="show-grid">
                            <div className="section-title"> 
                                <SectionTitle title={book.reviews.sectionTitle}/>
                            </div>
                                <Reviews reviews={book.reviews.reviews} />
                        </Row>
                    </Grid>
                </div>
            </div>
        )
    }
}

export default Details;                







// WEBPACK FOOTER //
// ./src/components/Details.js